
import {writable} from 'svelte/store';

const store = writable();

store.getLatestOne = async (appId, deviceEui, count = 0) => {
    const result = await fetch(`api/v1/environment/${appId}/latest/eui/${deviceEui}?count=${count}`);
    if(result.ok) {
        const environment = await result.json();
        return environment;
        //store.set(environment);
    }
    else {
        return {};
        //store.set();
    }
}



export default store;
